<script>
       
    
    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {string} [title]
     * @property {string} [description]
     * @property {any} sectionID
     * @property {any} selected
     * @property {any} icon
     * @property {boolean} [onlyItem]
     */
    let {
        title = '',
        description = '',
        sectionID,
        selected,
        icon,
        onlyItem = false
    } = $props();
    
    const dispatch = createEventDispatcher();

    function handleTabClick(e) {
        let target = e.target;

        // if e.target is not the tab item, then it's a child element
        // so we need to get the parent tab item
        if (target.classList.contains('tab-item') === false) {
            target = target.closest('.tab-item');
        }

        if (selected) return;
        dispatch('selected', target);
    }

</script>

<li>
    <button 
        onclick={handleTabClick} 
        class="tab-item interactive {selected ? 'selected' : ''}" 
        title={title} 
        data-sectionid={sectionID} 
        {...(selected && !onlyItem) ? { 'aria-current': 'true' } : {}} 
        {...onlyItem ? { 'tabindex': '-1', 'disabled': true} : {}}
    >
        {#if icon}
            <i class="material-icons" aria-hidden="true">{icon}</i>
        {/if}
        {#if icon && title.length > 0}
            <div class="half-space"></div>
        {/if}
        {#if title.length > 0}
            <h2 title={description}>{title}</h2>
        {/if}
    </button>
</li>

<style>
    /*
        Redesign styling from commit 78112c2e (wip: initial redesign) commented out
        below to restore the previous look without losing the changes.
    */
    .tab-item{
        display:flex;
        align-items: center;
        padding:0.6rem 1rem;
        /* padding:8px 14px; */
        margin:0.5rem 1px 0;
        background-color:rgba(255, 206, 44,0.5);
        border-radius:0.5rem 0.5rem 0 0;
        color: #000;
        /* background-color:#181818;
        border-radius:8px 8px 0 0;
        color:rgba(255, 255, 255, 0.5);
        font-size:11.5px;
        font-weight:600;
        letter-spacing:0.04em; */
    }

    .tab-item:hover{
        background-color:rgb(255, 206, 44);
        /* background-color:#222;
        color:#fff; */
    }

    .tab-item h2{
        text-transform:uppercase;
        font-size:0.9rem;
        font-weight:700;
        /* font-size:inherit;
        font-weight:inherit;
        letter-spacing:inherit; */
        white-space: nowrap;
        max-width: 250px;
        overflow-x: hidden;
        text-overflow: ellipsis;
    }

    .tab-item i{
        color:inherit;
        /* font-size:17px; */
    }

    .selected{
        background-color:rgb(255, 206, 44);
        color:black;
        /* background-color:#FFCE2C;
        color:#141414;
        font-weight:700;
        padding:9px 15px; */
    }

    /* .selected:hover{
        background-color:#FFCE2C;
        color:#141414;
    } */

    .half-space{
        width:0.5rem;
        height:0.5rem;
        /* width:7px;
        height:7px; */
    }
</style>